export default {
  configPage: {
    notFound: 'Workspace ID not found',
    title: 'Workspace Settings',
    dialogDescription: 'Manage workspace overview and API tokens',
    tabs: {
      overview: 'General',
      users: 'Users',
      apiTokens: 'Tokens',
      authorizedApps: 'Apps',
      security: 'Security'
    },
    dangerZone: {
      title: 'Danger Zone',
      description: 'Irreversible actions for this workspace.',
      deleteTitle: 'Delete workspace',
      deleteDescription: 'This action is permanent and cannot be undone. All workspace data will be removed.',
      deleteButton: 'Delete',
      confirmTitle: 'Confirm workspace deletion',
      confirmDescription: 'This action is irreversible. Type the workspace name to confirm.',
      confirmLabel: 'Type the workspace name to confirm:',
      confirmHint: 'Type "{{name}}" to confirm'
    }
  },
  overview: {
    title: 'General',
    description: 'Manage your workspace information and settings',
    saving: 'Saving...',
    save: 'Save'
  },
  users: {
    title: 'Workspace Users',
    description: 'Manage which users have access to this workspace',
    pendingInvites: 'Pending Invites',
    activeUsers: 'Active Users'
  },
  apiTokens: {
    title: 'API Tokens',
    description: 'Manage workspace-level API tokens for third-party access',
    create: 'Create',
    createTitle: 'Create API Token',
    createDesc: 'Create a new token linked to this workspace.',
    createSuccessDesc: 'Your API token has been created successfully. You can copy it now or access it later from the token list.',
    tokenName: 'Token name',
    tokenNamePlaceholder: 'e.g. Production Tool',
    setExpiration: 'Set expiration',
    expiresAt: 'Expires at',
    yourToken: 'Your API Token',
    copyToken: 'Copy token',
    copyWarning: '⚠️ Important: Copy this token now! After closing this dialog, only the token prefix will be shown for security reasons. The full token cannot be retrieved later.',
    noTokens: 'No API tokens',
    noTokensDesc: 'Create an API token to allow third-party tools to access scoped endpoints.',
    createFirst: 'Create your first token',
    availableApis: 'Available APIs',
    apisDescription: 'Endpoints accessible with API tokens from this workspace',
    swaggerLink: 'For full endpoint details, see the Swagger documentation',
    copy: 'Copy',
    copyPrefixBtn: 'Copy Prefix',
    copyFullToken: 'Copy full token',
    copyPrefix: 'Copy token prefix (regenerate to get full token)',
    regenerate: 'Regenerate',
    regenerateTitle: 'Regenerate token - creates a new token and shows it to you',
    active: 'Active',
    inactive: 'Inactive',
    created: 'Created',
    expires: 'Expires',
    usageCount: 'Usage count',
    tokenCopied: 'Token copied to clipboard',
    prefixCopied: 'Token prefix copied to clipboard',
    copyFailed: 'Failed to copy token',
    copyPrefixFailed: 'Failed to copy token prefix',
    revoked: 'Token revoked',
    renewed: 'Token renewed successfully',
    regenerated: 'Token regenerated successfully'
  },
  authorizedApps: {
    title: 'Connected Apps',
    description: 'Applications that have been granted access to this workspace via OAuth.',
    empty: 'No connected apps',
    emptyDesc: 'When applications connect to this workspace via OAuth, they will appear here.',
    columns: {
      app: 'Application',
      scopes: 'Permissions',
      lastUsed: 'Last used',
      authorizedAt: 'Authorized at',
      authorizedBy: 'Authorized by',
      status: 'Status'
    },
    status: {
      on: 'On',
      off: 'Off',
      onTooltip: 'Active session — the app has a fresh access token and is currently usable.',
      offTooltip: 'Idle — authorization is still valid, but the access token has expired. The app will reconnect automatically on next use.'
    },
    scopeLabels: {
      'mcp_read': 'MCP Read',
      'mcp_write': 'MCP Write',
      'mcp_execute': 'MCP Execute',
      'mcp_admin': 'MCP Admin',
      'api_read': 'API Read',
      'api_write': 'API Write',
      'api_execute': 'API Execute',
      'api_admin': 'API Admin'
    },
    neverUsed: 'Never',
    revoke: 'Revoke',
    revoked: 'Access revoked successfully',
    revokeError: 'Failed to revoke access',
    revokeDialog: {
      title: 'Revoke access',
      description: 'Are you sure you want to revoke access for "{{appName}}"? The application will immediately lose access to this workspace and will need to be re-authorized.'
    },
    share: {
      button: 'Share connection details',
      title: 'Connection details',
      description: 'Use these URLs and scopes to connect external applications to this workspace via OAuth.',
      mcpTitle: 'MCP Server',
      mcpDescription: 'Use with MCP-compatible clients (Claude, Cursor, Windsurf, etc.).',
      apiTitle: 'REST API',
      apiDescription: 'Use with apps that call the Prodgy REST endpoints directly via OAuth bearer tokens.',
      urlLabel: 'URL',
      scopesLabel: 'Available scopes',
      copyUrl: 'Copy URL',
      urlCopied: 'URL copied to clipboard',
      copyFailed: 'Failed to copy to clipboard'
    }
  }
};
